<template>
  <div class="message">
    <second-menu-link-content>
      <template v-slot:header>
        <span>通知消息</span>
      </template>
      <template v-slot:content>
        <div class="message-main">
          <p class="message-main-title">通知消息</p>
          <ul class="message-list" v-if="messageData.length>0">
            <li
              :class="value.isRead ===0?'message-li':'message-li isRead'"
              v-for="(value,index) in messageData "
              :key="index"
            >
              <p>
                <span class="label" v-if="value.isRead ===0">[未读]</span>
                <span class="label" v-else>[已读]</span>
                <span class="text">{{value.content}}</span>
                <span
                  class="detail"
                  @click="toDetailPage(value.id,value.isRead,value.type,value.code)"
                >点击查看详情</span>
              </p>
              <span class="time">{{value.time}}</span>
            </li>
          </ul>
          <div v-else class="message-list nothing" v-loading="loading">暂无信息</div>
          <div class="pagination-tpl-container">
            <pagination-tpl
              class="pagination-tpl"
              :total="total"
              :currentPage="page"
              @queryChange="handleQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import { getDBOperationPermission } from "common/js/storage"; // 权限数据接口
import { formaTimeToSecond } from "common/js/util.js";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import DBHome from "models/db/home.js";
const dbHome = new DBHome();
export default {
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },
  data() {
    return {
      operationList: [], // 权限数据
      operationsBtns: {
        roleOrderShow: "ROLE_ORDER_show",
        roleOrderCancelShow: "ROLE_ORDER_cancel_show",
        roleStorageGoodsSearch: "ROLE_STORAGE_goods_search"
      },
      page: 1,
      total: 0,
      messageData: [],
      loading: true
    };
  },
  created() {
    this.operationList = getDBOperationPermission();
    this.getMessageData();
  },
  methods: {
    toSystemHome() {
      this.$router.push("/admin/home/system-index/system-home");
    },
    // 获取消息通知
    getMessageData() {
      let currentPage = this.page;
      dbHome.getDBNotice(currentPage).then(res => {
        console.log(res);
        if (res.success) {
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.time = formaTimeToSecond(value.createTime);
            obj.type = value.type;
            obj.code = value.content;
            obj.isRead = value.isRead;
            if (value.type === 1) {
              obj.title = "客户发起订单";
              obj.content = `客户${value.username}发起了订单，订单号：${value.content}`;
            } else if (value.type === 2) {
              obj.title = "客户支付";
              obj.content = `客户${value.username}已成功支付订单${value.content}，请尽快处理`;
            } else if (value.type === 3) {
              obj.title = "客户发起退单";
              obj.content = `客户${value.username}发起了退单，退单号：${value.content}`;
            } else if (value.type === 4) {
              obj.title = "客户已退货";
              obj.content = `退单${value.content}已经退货，请及时处理。`;
            } else if (value.type === 5) {
              obj.title = "商品售罄";
              obj.content = `编号为${value.content}的商品即将售罄，请注意库存变化，以免错过商机。`;
            }
            arr.push(obj);
          });
          this.messageData = arr;
          this.loading = false;
        }
      });
    },
    handleQueryChange(data) {
      this.page = data.currentPage;
      window.screenTop = 0;
      this.getMessageData();
    },
    toDetailPage(id, isRead, type, code) {
      if (isRead === 0) {
        let data = {
          id
        };
        dbHome.postDBReadNotice(data).then(res => {
          console.log(res);
        });
      }
      if (type === 1 || type === 2) {
        if (
          this.operationList.indexOf(this.operationsBtns.roleOrderShow) !== -1
        ) {
          this.$router.push(
            `/admin/order/order-form/order-detail?orderCode=${code}`
          );
        } else {
          this.$message.error("暂无权限");
        }
      } else if (type === 3 || type === 4) {
        if (
          this.operationList.indexOf(
            this.operationsBtns.roleOrderCancelShow
          ) !== -1
        ) {
          this.$router.push(
            `/admin/order/return-form/cancellation-detail?refundCode=${code}`
          );
        } else {
          this.$message.error("暂无权限");
        }
      } else if (type === 5) {
        if (
          this.operationList.indexOf(
            this.operationsBtns.roleStorageGoodsSearch
          ) !== -1
        ) {
          this.$router.push({
            name: "goods-inventory",
            params: {
              code
            }
          });
        } else {
          this.$message.error("暂无权限");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.message {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .message-main {
    .message-main-title {
      height: 32px;
      background: rgba(245, 247, 250, 1);
      border-radius: 8px 8px 0px 0px;
      line-height: 32px;
      padding-left: 16px;
      font-size: 16px;
    }
    .message-list {
      .message-li {
        height: 40px;
        box-sizing: border-box;
        border-bottom: 1px solid #f5f7fa;
        display: flex;
        align-items: center;
        font-size: 14px;
        justify-content: space-between;
        padding-right: 10px;
        .label {
          padding: 0 15px;
          color: #666666;
        }
        .text {
          margin-right: 10px;
        }
        .detail {
          color: #3d74f2;
          cursor: pointer;
          margin-right: 30px;
        }
        .time {
          color: #999999;
        }
      }
      .isRead {
        .text {
          color: #999999;
        }
        .detail {
          color: #999999;
        }
      }
      li:last-child {
        border-bottom: 0;
      }
    }
    .nothing {
      line-height: 250px;
      text-align: center;
    }
    .pagination-tpl-container {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
